import styled from 'styled-components'

import { Button } from 'components/Button'

import rectangle from 'assets/images/rectangle.svg'

import {
  StyledPhoneInput,
  baseColumnStyles,
  basePageStyles,
} from 'common-styles'
import { Color, HEADER_HEIGHT } from 'root-constants/common'

export const StyledPhoneNumberVariant4 = {
  Wrapper: styled.div`
    ${basePageStyles};
    padding-top: ${HEADER_HEIGHT}px;
    min-height: 100dvh;
  `,
  Column: styled.div`
    ${baseColumnStyles};
    padding: 24px 0 32px;
  `,
  TitleWrapper: styled.div`
    max-width: 261px;
    width: 100%;
    border-radius: 12px 12px 12px 0;
    background-color: #f2f3f5;
    padding: 10px 12px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
    position: relative;
    margin-bottom: 32px;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;

    :before {
      display: block;
      content: '';
      background-image: url(${rectangle});
      background-size: 12px;
      position: absolute;
      left: -12px;
      bottom: 0;
      width: 12px;
      height: 12px;
    }
  `,
  SecureWrapper: styled.div`
    max-width: 229px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
  `,
  SecureContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 4px;
    font-size: 9px;
    color: #000;
    font-weight: 700;
    line-height: 12px;
    border-radius: 4px;
    background-color: ${Color.WHITE};
  `,
  PhoneForm: styled.form`
    width: 327px;
    padding: 0;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  PhoneNumberInput: styled(StyledPhoneInput)`
    border: 1px solid #cacaca;
    background: #fff;
    width: 327px;
    height: 64px;
  `,
  PhoneErrorText: styled.p`
    color: #ff0000;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 20px;
  `,
  Button: styled(Button)`
    width: 327px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    img {
      width: 24px;
      height: 24px;
    }
  `,
}
